"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadTableRef = exports.LoadTableRow = void 0;
var mobx_1 = require("mobx");
var mobx_keystone_1 = require("mobx-keystone");
var moment_1 = __importDefault(require("moment"));
var load_1 = require("../constants/load");
var api = __importStar(require("../services/api"));
var models_1 = require("../utils/models");
var LoadTableRow = /** @class */ (function (_super) {
    __extends(LoadTableRow, _super);
    function LoadTableRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.etaTracker = null;
        _this.getRefId = function () { return "".concat(_this.id); };
        _this.updateETAs = (0, mobx_keystone_1._async)(function (force) {
            var rootStore, currentGPSPosition, fn, entities, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore)
                            return [2 /*return*/];
                        currentGPSPosition = rootStore.currentGPSPosition;
                        if (!(force || currentGPSPosition)) return [3 /*break*/, 5];
                        fn = void 0;
                        if (rootStore.token) {
                            fn = api.fetchLoadETA(rootStore.token, this.id, rootStore.currentGPSPosition);
                        }
                        else {
                            fn = api.fetchLoadETAByManifestLinkId(rootStore.token, this.manifestLinkId, rootStore.currentGPSPosition);
                        }
                        entities = void 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fn];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log('[DEBUG][Load.updateETAs] error', error_1);
                        return [2 /*return*/];
                    case 4:
                        if (entities) {
                            this.etas = entities;
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
        _this.updateStatus = (0, mobx_keystone_1._async)(function (status, description) {
            var rootStore, entities, error_, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore || !rootStore.token)
                            return [2 /*return*/];
                        entities = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.dispatcherUpdateLoadStatus(rootStore.token, this.id, {
                                status: status,
                                description: description,
                            })];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.log('[DEBUG] error', error_2.message);
                        error_ = (0, models_1.getError)(error_2);
                        return [3 /*break*/, 4];
                    case 4:
                        if (entities) {
                            rootStore.setLoadTableRow(entities);
                        }
                        return [2 /*return*/, error_ || (0, models_1.getSuccess)()];
                }
            });
        });
        _this.updatePriority = (0, mobx_keystone_1._async)(function (priority) {
            var rootStore, entities, error_, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore || !rootStore.token)
                            return [2 /*return*/];
                        entities = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.dispatcherUpdatePriority(rootStore.token, this.id, {
                                priority: priority,
                            })];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.log('[DEBUG] error', error_3.message);
                        error_ = (0, models_1.getError)(error_3);
                        return [3 /*break*/, 4];
                    case 4:
                        if (entities) {
                            entities.map(function (row) { return rootStore.setLoadTableRow(row); });
                        }
                        return [2 /*return*/, error_ || (0, models_1.getSuccess)()];
                }
            });
        });
        _this.assignDriver = (0, mobx_keystone_1._async)(function (driver) {
            var rootStore, entities, error_, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore || !rootStore.token)
                            return [2 /*return*/];
                        entities = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.dispatcherAssignDriver(rootStore.token, this.id, {
                                driver: driver,
                            })];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.log('[DEBUG] error', error_4.message);
                        error_ = (0, models_1.getError)(error_4);
                        return [3 /*break*/, 4];
                    case 4:
                        if (entities) {
                            entities.map(function (row) { return rootStore.setLoadTableRow(row); });
                        }
                        return [2 /*return*/, error_ || (0, models_1.getSuccess)()];
                }
            });
        });
        return _this;
    }
    Object.defineProperty(LoadTableRow.prototype, "isActive", {
        // onAttachedToRootStore() {
        //   if (this.isActive) {
        //     this.updateETAs(true);
        //     this.etaTracker = setInterval(() => {
        //       if (!this.isActive && this.etaTracker) {
        //         clearInterval(this.etaTracker as number);
        //       }
        //       this.updateETAs();
        //     }, ETA_INTERVAL + Math.random() * 1000);
        //   } else {
        //     console.log('[DEBUG] Not getting ETA of', this.status, 'load', this.id);
        //   }
        //   return () => {
        //     if (this.etaTracker) {
        //       clearInterval(this.etaTracker as number);
        //     }
        //   };
        // }
        get: function () {
            return load_1.ACTIVE_LOAD_STATUSES.includes(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoadTableRow.prototype, "displayStatus", {
        get: function () {
            return (0, load_1.getDisplayStatus)(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoadTableRow.prototype, "isPickupStatus", {
        // @asDateRange('dropoffWindow')
        // dropoffWindowDateRange!: DateTimeRangeDates;
        get: function () {
            return load_1.PICKUP_LOAD_STATUSES.includes(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoadTableRow.prototype, "isDropoffStatus", {
        get: function () {
            return load_1.DROPOFF_LOAD_STATUSES.includes(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoadTableRow.prototype, "isAS400StatusValid", {
        get: function () {
            return (this.as400Status === load_1.AS400_STATUS.NA ||
                this.as400Status === load_1.AS400_STATUS.COMPLETE);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoadTableRow.prototype, "isDatesProvided", {
        get: function () {
            var pickupValid = this.pickupWindow && this.pickupWindow.lower && this.pickupWindow.upper;
            var dropoffValid = this.dropoffWindow &&
                this.dropoffWindow.lower &&
                this.dropoffWindow.upper;
            return pickupValid && dropoffValid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoadTableRow.prototype, "timestamp", {
        get: function () {
            return "".concat(new Date(this.createdAt).toLocaleDateString(), " - ").concat(new Date(this.createdAt).toLocaleTimeString());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoadTableRow.prototype, "currentETA", {
        get: function () {
            if (!this.etas) {
                return null;
            }
            return this.isPickupStatus ? this.etas.pickupEta : this.etas.dropoffEta;
        },
        enumerable: false,
        configurable: true
    });
    LoadTableRow.prototype.pickupOnTimeStatus = function (now) {
        var time = now ? now : (0, moment_1.default)();
        var eta;
        var checkin;
        var windowStart;
        var windowEnd;
        switch (this.status) {
            case load_1.LOAD_STATUS.UNASSIGNED:
            case load_1.LOAD_STATUS.PENDING_ACCEPTANCE:
            case load_1.LOAD_STATUS.ASSIGNED:
            case load_1.LOAD_STATUS.DECLINED:
            case load_1.LOAD_STATUS.ACTIVE:
                return load_1.ON_TIME_STATUS.PROCESSING;
            case load_1.LOAD_STATUS.DELIVERED:
                return load_1.ON_TIME_STATUS.DELIVERED;
            case load_1.LOAD_STATUS.COMPLETED:
                return load_1.ON_TIME_STATUS.COMPLETED;
        }
        if (!this.etas || !this.etas.pickupEta || !this.pickupWindow) {
            return load_1.ON_TIME_STATUS.UNKNOWN;
        }
        switch (this.status) {
            case load_1.LOAD_STATUS.PICKUP_ACCEPTED:
            case load_1.LOAD_STATUS.PICKUP_GOING:
                eta = (0, moment_1.default)(this.etas.pickupEta.eta);
                windowStart = (0, moment_1.default)(this.pickupWindow.lower);
                windowEnd = (0, moment_1.default)(this.pickupWindow.upper);
                if (time > windowEnd) {
                    return load_1.ON_TIME_STATUS.PICKUP_MISSED;
                }
                else if (eta < windowStart) {
                    return load_1.ON_TIME_STATUS.PICKUP_EARLY;
                }
                else if (eta > windowEnd) {
                    return load_1.ON_TIME_STATUS.PICKUP_AT_RISK;
                }
                return load_1.ON_TIME_STATUS.PICKUP_ON_TIME;
            case load_1.LOAD_STATUS.PICKUP_ARRIVED:
                return load_1.ON_TIME_STATUS.PICKUP_ARRIVED;
            case load_1.LOAD_STATUS.PICKUP_CHECKIN:
                checkin = (0, moment_1.default)(this.pickupCheckedinOn);
                if (time.diff(checkin, 'minutes') > 120) {
                    return load_1.ON_TIME_STATUS.PICKUP_DETENTION;
                }
                return load_1.ON_TIME_STATUS.PICKUP_CHECKEDIN;
            default:
                return load_1.ON_TIME_STATUS.PICKED_UP;
        }
    };
    LoadTableRow.prototype.dropoffOnTimeStatus = function (now) {
        var time = now ? now : (0, moment_1.default)();
        var eta;
        var checkin;
        var windowStart;
        var windowEnd;
        switch (this.status) {
            case load_1.LOAD_STATUS.UNASSIGNED:
            case load_1.LOAD_STATUS.PENDING_ACCEPTANCE:
            case load_1.LOAD_STATUS.ASSIGNED:
            case load_1.LOAD_STATUS.DECLINED:
            case load_1.LOAD_STATUS.ACTIVE:
                return load_1.ON_TIME_STATUS.PROCESSING;
            case load_1.LOAD_STATUS.DELIVERED:
                return load_1.ON_TIME_STATUS.DELIVERED;
            case load_1.LOAD_STATUS.COMPLETED:
                return load_1.ON_TIME_STATUS.COMPLETED;
        }
        if (!this.etas || !this.etas.dropoffEta || !this.dropoffWindow) {
            return load_1.ON_TIME_STATUS.UNKNOWN;
        }
        switch (this.status) {
            case load_1.LOAD_STATUS.PICKUP_GOING:
            case load_1.LOAD_STATUS.PICKUP_ARRIVED:
            case load_1.LOAD_STATUS.PICKUP_CHECKIN:
            case load_1.LOAD_STATUS.DROPOFF_ACCEPTED:
            case load_1.LOAD_STATUS.DROPOFF_GOING:
                eta = (0, moment_1.default)(this.etas.dropoffEta.eta);
                windowStart = (0, moment_1.default)(this.dropoffWindow.lower);
                windowEnd = (0, moment_1.default)(this.dropoffWindow.upper);
                if (time > windowEnd) {
                    return load_1.ON_TIME_STATUS.DROPOFF_MISSED;
                }
                else if (eta < windowStart) {
                    return load_1.ON_TIME_STATUS.DROPOFF_EARLY;
                }
                else if (eta > windowEnd) {
                    return load_1.ON_TIME_STATUS.DROPOFF_AT_RISK;
                }
                return load_1.ON_TIME_STATUS.DROPOFF_ON_TIME;
            case load_1.LOAD_STATUS.DROPOFF_ARRIVED:
                return load_1.ON_TIME_STATUS.DROPOFF_ARRIVED;
            case load_1.LOAD_STATUS.DROPOFF_CHECKIN:
                checkin = (0, moment_1.default)(this.dropoffCheckedinOn);
                if (time.diff(checkin, 'minutes') > 120) {
                    return load_1.ON_TIME_STATUS.DROPOFF_DETENTION;
                }
                return load_1.ON_TIME_STATUS.DROPOFF_CHECKEDIN;
            default:
                return load_1.ON_TIME_STATUS.COMPLETED;
        }
    };
    Object.defineProperty(LoadTableRow.prototype, "onTimeStatus", {
        get: function () {
            var now = (0, moment_1.default)();
            switch (this.status) {
                case load_1.LOAD_STATUS.UNASSIGNED:
                case load_1.LOAD_STATUS.PENDING_ACCEPTANCE:
                case load_1.LOAD_STATUS.DECLINED:
                    return load_1.ON_TIME_STATUS.PROCESSING;
                case load_1.LOAD_STATUS.ASSIGNED:
                case load_1.LOAD_STATUS.ACTIVE:
                    return load_1.ON_TIME_STATUS.LOAD_STARTED;
                case load_1.LOAD_STATUS.DELIVERED:
                    return load_1.ON_TIME_STATUS.DELIVERED;
                case load_1.LOAD_STATUS.COMPLETED:
                    return load_1.ON_TIME_STATUS.COMPLETED;
            }
            if (!this.etas || !this.etas.pickupEta || !this.etas.dropoffEta) {
                return load_1.ON_TIME_STATUS.UNKNOWN;
            }
            switch (this.status) {
                case load_1.LOAD_STATUS.PICKUP_ACCEPTED:
                case load_1.LOAD_STATUS.PICKUP_GOING:
                case load_1.LOAD_STATUS.PICKUP_ARRIVED:
                case load_1.LOAD_STATUS.PICKUP_CHECKIN:
                    return this.pickupOnTimeStatus(now);
                case load_1.LOAD_STATUS.DROPOFF_ACCEPTED:
                case load_1.LOAD_STATUS.DROPOFF_GOING:
                case load_1.LOAD_STATUS.DROPOFF_ARRIVED:
                case load_1.LOAD_STATUS.DROPOFF_CHECKIN:
                    return this.dropoffOnTimeStatus(now);
            }
            return load_1.ON_TIME_STATUS.UNKNOWN;
        },
        enumerable: false,
        configurable: true
    });
    LoadTableRow.prototype.update = function (data) {
        var rootStore = (0, mobx_keystone_1.getRootStore)(this);
        if (!rootStore) {
            return;
        }
        Object.assign(this, data);
    };
    __decorate([
        (0, models_1.asDate)('loadStartedOn')
    ], LoadTableRow.prototype, "loadStartedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('pickupStartedOn')
    ], LoadTableRow.prototype, "pickupStartedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('pickupArrivedOn')
    ], LoadTableRow.prototype, "pickupArrivedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('pickupCheckedinOn')
    ], LoadTableRow.prototype, "pickupCheckedinOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('pickupDepartedOn')
    ], LoadTableRow.prototype, "pickupDepartedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('dropoffArrivedOn')
    ], LoadTableRow.prototype, "dropoffArrivedOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('dropoffCheckedinOn')
    ], LoadTableRow.prototype, "dropoffCheckedinOnDate", void 0);
    __decorate([
        (0, models_1.asDate)('dropoffCompletedOn')
    ], LoadTableRow.prototype, "dropoffCompletedOnDate", void 0);
    __decorate([
        mobx_1.computed
    ], LoadTableRow.prototype, "isPickupStatus", null);
    __decorate([
        mobx_1.computed
    ], LoadTableRow.prototype, "isDropoffStatus", null);
    __decorate([
        mobx_1.computed
    ], LoadTableRow.prototype, "isAS400StatusValid", null);
    __decorate([
        mobx_1.computed
    ], LoadTableRow.prototype, "isDatesProvided", null);
    __decorate([
        mobx_1.computed
    ], LoadTableRow.prototype, "timestamp", null);
    __decorate([
        mobx_1.computed
    ], LoadTableRow.prototype, "onTimeStatus", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], LoadTableRow.prototype, "update", null);
    __decorate([
        mobx_keystone_1.modelFlow
    ], LoadTableRow.prototype, "updateETAs", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], LoadTableRow.prototype, "updateStatus", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], LoadTableRow.prototype, "updatePriority", void 0);
    __decorate([
        mobx_keystone_1.modelFlow
    ], LoadTableRow.prototype, "assignDriver", void 0);
    LoadTableRow = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/LoadTableRow')
    ], LoadTableRow);
    return LoadTableRow;
}((0, mobx_keystone_1.Model)({
    id: (0, mobx_keystone_1.prop)(),
    dmId: (0, mobx_keystone_1.prop)(),
    manifestNumber: (0, mobx_keystone_1.prop)(),
    as400ManifestNumber: (0, mobx_keystone_1.prop)(),
    manifestId: (0, mobx_keystone_1.prop)(),
    orderId: (0, mobx_keystone_1.prop)(),
    orderNumber: (0, mobx_keystone_1.prop)(),
    customerOrderNumber: (0, mobx_keystone_1.prop)(),
    billOfLadingNumber: (0, mobx_keystone_1.prop)(),
    organization: (0, mobx_keystone_1.prop)(),
    terminal: (0, mobx_keystone_1.prop)(),
    manifestLinkId: (0, mobx_keystone_1.prop)(),
    orderLegLinkId: (0, mobx_keystone_1.prop)(),
    status: (0, mobx_keystone_1.prop)(),
    as400Status: (0, mobx_keystone_1.prop)(),
    loadType: (0, mobx_keystone_1.prop)(),
    loadDescription: (0, mobx_keystone_1.prop)(),
    loadWeight: (0, mobx_keystone_1.prop)(),
    estimatedTravelDistance: (0, mobx_keystone_1.prop)(),
    specialEquipment: (0, mobx_keystone_1.prop)(),
    loadStartedOn: (0, mobx_keystone_1.prop)(),
    driver: (0, mobx_keystone_1.prop)(),
    driverName: (0, mobx_keystone_1.prop)(),
    trailerNumber: (0, mobx_keystone_1.prop)(),
    sealNumber: (0, mobx_keystone_1.prop)(),
    expedite: (0, mobx_keystone_1.prop)(),
    loadNotes: (0, mobx_keystone_1.prop)(),
    broker: (0, mobx_keystone_1.prop)(),
    shipper: (0, mobx_keystone_1.prop)(),
    pickupNumber: (0, mobx_keystone_1.prop)(),
    pickupWindow: (0, mobx_keystone_1.prop)(),
    pickupStreet1: (0, mobx_keystone_1.prop)(),
    pickupStreet2: (0, mobx_keystone_1.prop)(),
    pickupCity: (0, mobx_keystone_1.prop)(),
    pickupState: (0, mobx_keystone_1.prop)(),
    pickupZipCode: (0, mobx_keystone_1.prop)(),
    pickupStartedOn: (0, mobx_keystone_1.prop)(),
    pickupNearbyNotified: (0, mobx_keystone_1.prop)(false),
    pickupArrivedOn: (0, mobx_keystone_1.prop)(),
    pickupCheckedinOn: (0, mobx_keystone_1.prop)(),
    pickupDepartedOn: (0, mobx_keystone_1.prop)(),
    consignee: (0, mobx_keystone_1.prop)(),
    dropoffNumber: (0, mobx_keystone_1.prop)(),
    dropoffWindow: (0, mobx_keystone_1.prop)(),
    dropoffStreet1: (0, mobx_keystone_1.prop)(),
    dropoffStreet2: (0, mobx_keystone_1.prop)(),
    dropoffCity: (0, mobx_keystone_1.prop)(),
    dropoffState: (0, mobx_keystone_1.prop)(),
    dropoffZipCode: (0, mobx_keystone_1.prop)(),
    dropoffNearbyNotified: (0, mobx_keystone_1.prop)(false),
    dropoffArrivedOn: (0, mobx_keystone_1.prop)(),
    dropoffCheckedinOn: (0, mobx_keystone_1.prop)(),
    dropoffCompletedOn: (0, mobx_keystone_1.prop)(),
    linkedLegs: (0, mobx_keystone_1.prop)(Array),
    poNumberShipper: (0, mobx_keystone_1.prop)(),
    poNumberConsignee: (0, mobx_keystone_1.prop)(),
    etas: (0, mobx_keystone_1.prop)(),
    reason: (0, mobx_keystone_1.prop)(),
    createdAt: (0, mobx_keystone_1.prop)(),
    priority: (0, mobx_keystone_1.prop)(1),
})));
exports.LoadTableRow = LoadTableRow;
exports.loadTableRef = (0, mobx_keystone_1.rootRef)('doc-mate/LoadTableRef', {
    getId: function (target) {
        if (target instanceof LoadTableRow) {
            return "".concat(target.id);
        }
    },
});
